<script lang="ts">
    import type { DesignEditor } from '$src/application/designs/DesignEditor';
    import { DesignScene } from '$src/domain/designs/DesignScene';
    import { SceneViewCanvas } from '$src/infrastructure/designs/editor/SceneViewCanvas';
    import { SideViewCanvas } from '$src/infrastructure/designs/editor/SideViewCanvas';
    import { onMount, onDestroy, setContext, getContext } from 'svelte';
    //import { designSceneContext } from './DesignSceneContext.js';
   
    const editor : DesignEditor = getContext('editor');
    let sceneViewCanvas: SideViewCanvas;
    
    //var designScene : DesignScene = getContext('scene');
    //console.log('myscene : ' + designScene.text);

    function init() {
     
        let container = document.getElementById('side-container');

        sceneViewCanvas = new SideViewCanvas(new DesignScene(), container!);
        sceneViewCanvas.initialize();
        editor.setSceneViewCanvas(sceneViewCanvas);
        
        //const designSceneController = new DesignSceneController(designScene, sceneViewCanvas);
        
        //
        //designSceneContext.set(designScene);
    }
  
    onMount(init);

    onDestroy(() => {
    });
  </script>
  
  <style>
    #side-container {
      width: 100%;
      height: 100%;
    }
  </style>
  
  <div id="side-container">
  </div>
  